// extracted by mini-css-extract-plugin
module.exports = {"container":"DobCheck_container__wgmGX","label":"DobCheck_label__LkFOC","inputWrapper":"DobCheck_inputWrapper__qq4t6","submitButton":"DobCheck_submitButton__0o6F4"};